import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {HasPermission} from "@/utils/permisshoinHelper";
import PermissionsV1 from "@/router/permissions/v1";

export default defineStore("router", () => {
    const routes = ref([
        {
            index: 0,
            name: RouteGroups.MAIN,
            children: [
                {
                    name: "selections",
                    slug: "selection",
                    access: PermissionsV1["SELECTIONS.INDEX"]
                },
            ],
        },
        {
            index: 4,
            name: RouteGroups.PERSON,
            children: [
                {
                    name: "resumes",
                    slug: "persons",
                    access: PermissionsV1["PERSONS.INDEX"]
                },
            ],
        },
        {
            index: 6,
            name: RouteGroups.RESERVE,
            children: [
                {
                    name: "commissions",
                    slug: "commissions",
                    access: PermissionsV1["HRMIS.STATES.COMMISSIONS.INDEX"]
                },
            ],
        },
        {
            index: 7,
            name: RouteGroups.RESERVE,
            children: [
                {
                    name: "positions",
                    slug: "positions",
                    access: PermissionsV1["HRMIS.POSITIONS.INDEX"]
                },
            ],
        },
        {
            index: 8,
            name: RouteGroups.RESERVE,
            children: [
                {
                    name: "requests",
                    slug: "requests",
                    icon: "pi pi-inbox",
                    children: [
                        {
                            name: "awaiting_requests",
                            slug: "awaiting",
                            access: PermissionsV1["HRMIS.POSITIONS.REQUESTS.ON_AWAITING"],
                        },
                        {
                            name: "my_awaiting_requests",
                            slug: "my-awaiting",
                            access: PermissionsV1["HRMIS.POSITIONS.REQUESTS.MY"],
                        },
                    ],
                },
            ],
        },
        // {
        //     index: 8,
        //     name: RouteGroups.RESERVE,
        //     children: [
        //         {
        //             name: "analytics",
        //             slug: "analytics",
        //         },
        //     ],
        // },
    ]);
    const sortedRoutes = computed(() =>
        routes.value.reduce((accum, group) => {
            const children = group.children.filter((i) => {
                if (!i.access) return true;
                return HasPermission(i.access);
            }).map((i) => {
                if (!i.children) return i;
                const subChildren = i.children.filter((sub) => {
                    if (!sub.access) return true;
                    return HasPermission(sub.access);
                });
                return { ...i, children: subChildren };
            }).filter((i) => {
                if (!i.children) return true;
                return i.children.length > 0;
            });

            if (children.length) {
                accum.push({
                    ...group,
                    children
                })
            }

            return accum;
        }, []).sort(({index: a}, {index: b}) => a - b),
    );

    const addGroup = (groupName, groupIndex = 0) => {
        let group = routes.value.find(({name}) => name === groupName);

        if (!group) {
            group = {
                index: groupIndex,
                name: groupName,
                children: [],
            };
            routes.value.push(group);
        } else {
            group.index = groupIndex;
        }

        return group;
    };
    const addToGroup = (groupName, ...children) => {
        let group = routes.value.find(({name}) => name === groupName);

        if (!group) group = addGroup(groupName);

        group.children.push(...children);
    };

    return {
        routes,
        sortedRoutes,
        addGroup,
        addToGroup,
    };
});

export const RouteGroups = {
    MAIN: "main",
    STATE: "state",
    WORK: "work",
    STATISTIC: "statistic",
    PERSON: "person",
    VACANCY: "vacancy",
    RESERVE: "reserve",
};
